const env = import.meta.env;

/**
 * PLATEAU配信URLはここへ集約する。
 * latest URLはサービス側の更新を受け入れるため、起動時に採用URLをログへ残す。
 */
export const DATA_SOURCES = Object.freeze({
  cityCode: '36201',
  buildingLod1:
    env.VITE_PLATEAU_BLDG_LOD1_URL ??
    'https://api.plateauview.mlit.go.jp/datacatalog/3dtiles/36201-bldg-lod1-texture-latest/tileset.json',
  // Step 2で検証する。Step 1では読み込まない。
  buildingLod2:
    env.VITE_PLATEAU_BLDG_LOD2_URL ??
    'https://api.plateauview.mlit.go.jp/datacatalog/3dtiles/36201-bldg-lod2-texture-latest/tileset.json',
  terrain:
    env.VITE_PLATEAU_TERRAIN_URL ?? 'https://tile.plateauview.mlit.go.jp/terrain',
  // 徳島市の水部3D Tilesは空のルートだけを返すため、標準では同梱GeoJSONを表示する。
  // 配信済みの水部3D Tilesを利用する場合だけ環境変数で上書きする。
  water: env.VITE_PLATEAU_WATER_URL ?? null,
  waterGeoJson:
    env.VITE_WATER_GEOJSON_URL ?? '/data/tokushima-water-clean.geojson',
  // 初期カメラ付近だけを、公式CityGML DEM LOD3から変換した成果物。
  // 本番で外部ストレージへ移す場合は環境変数で上書きする。
  terrainLod3:
    env.VITE_LOD3_TERRAIN_TILESET_URL ??
    '/data/lod3/tokushima-center/tileset.json',
  roads:
    env.VITE_PLATEAU_ROAD_URL ??
    'https://api.plateauview.mlit.go.jp/datacatalog/mvt/36201-tran-lod1-latest/tilejson.json',
  roadTileTemplate:
    env.VITE_PLATEAU_ROAD_TILE_URL ??
    'https://assets.cms.plateau.reearth.io/assets/f0/bc196d-3205-453f-8261-a9b0dfa5788b/36201_tokushima-shi_city_2023_citygml_2_op_tran_mvt_lod1/{z}/{x}/{y}.mvt',
  ortho:
    env.VITE_PLATEAU_ORTHO_URL ??
    'https://tile.plateauview.mlit.go.jp/tiles/plateau-ortho-2023/{z}/{x}/{y}.png',
  // PLATEAU-Orthoを優先し、配信タイルが欠けている場合は国土地理院の
  // 航空写真へ切り替える。道路地図だけのOpenStreetMapは最終フォールバック。
  gsiAerial: 'https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg',
  fallbackImagery: 'https://tile.openstreetmap.org/',
  gsiStandard: 'https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png',
  retrievedAt: '2026-09-17',
} as const);
